module.exports = __webpack_public_path__ + "img/黄老师7156.51f5a46a.jpg";